import React, { useContext } from 'react';
import { useTheme } from '@emotion/react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { ThemeContext } from '../theme';

const Chip = (props) => {
  const context = useContext(ThemeContext);
  let chip;
  const theme = useTheme();

  if (theme && theme.chip) {
    chip = theme.chip;
  } else {
    chip = context.theme.chip;
  }

  const {
    background: chipBackground,
    color: chipColor,
    height: chipHeight,
    fontSize: chipFontSize,
    closeBtnHoverColor
  } = chip;

  const styles = StyleSheet.create({
    chip: {
      background: chipBackground,
      color: chipColor,
      height: chipHeight,
      fontSize: chipFontSize
    },
    avatarIcon: {
      fontSize: '16px',
      textAlign: 'center',
      marginRight: '8px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    avatarImage: {
      height: '24px',
      width: 'auto',
      maxHeight: '24px'
    },
    closeIcon: {
      height: '100%',
      width: '24px',
      textAlign: 'center',
      ':hover': {
        color: closeBtnHoverColor
      }
    }
  });

  return (
    <div
      key={props.id}
      className="fx"
      style={{
        background: chipBackground,
        color: chipColor,
        padding: '4px',
        marginRight: '4px',
        borderRadius: '5px',
        minWidth: '75px',
        marginBottom: '4px',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}
    >
      {/* Chip icon */}
      {props.icon
        ? <div className={css(styles.avatarIcon)}>
            {!props.iconClass
              ? <img
                  className={css(styles.avatarImage)}
                  src={props.icon}
                  alt="chip-icon"
                />
              : <i className="fa fa-circle" />
            }
          </div>
        : null
      }
      {/* Text */}
      <div>
        {props.text}
      </div>
      {/* Close icon */}
      {props.showCloseIcon
        ? <div
            className={css(styles.closeIcon)}
            onClick={(e) => {
              console.log('Chip close btn parent');
              e.stopPropagation();
              props.onClose(props.id);
            }}
          >
            <i
              className="fa fa-close"
              onClick={(e) => {
                console.log('Chip close btn icon');
                e.stopPropagation();
                props.onClose(props.id);
              }}
            />
          </div>
        : null
      }
    </div>
  );
};

export { Chip };
